"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationProvider = ConversationProvider;
exports.useConversationContext = useConversationContext;
var _react = _interopRequireWildcard(require("react"));
var _conversationReducer = require("./conversationReducer");
var _normalize = require("../core/normalize");
var _channelAdapter = require("../core/channelAdapter");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const ConversationContext = /*#__PURE__*/(0, _react.createContext)(null);

// Owns the conversation-selection state (screen + active conversation) that
// used to be ~15 separate useState fields in ConversationBody.js, plus the
// single adapter connection lifecycle. `adapter` is created once by the
// consuming app (e.g. createSocketIoAdapter(...)) and connected exactly once
// here — this is what replaces the old `const socket = io(url)` that ran on
// every render.
function ConversationProvider(_ref) {
  let adapter = _ref.adapter,
    chatClient = _ref.chatClient,
    currentUser = _ref.currentUser,
    children = _ref.children;
  const _useReducer = (0, _react.useReducer)(_conversationReducer.conversationReducer, _conversationReducer.initialConversationState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  (0, _react.useEffect)(() => {
    (0, _channelAdapter.assertChannelAdapter)(adapter);
    adapter.connect();
    return () => adapter.disconnect();
    // adapter is expected to be a stable instance for the lifetime of the
    // provider — recreating it is the caller's responsibility, not implied by
    // any other state here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adapter]);
  const selectConversation = input => {
    dispatch({
      type: "SELECT_CONVERSATION",
      conversation: (0, _normalize.normalizeConversation)(input)
    });
  };
  const setScreen = screen => dispatch({
    type: "SET_SCREEN",
    screen
  });
  const updateGroupMeta = patch => dispatch({
    type: "UPDATE_GROUP_META",
    patch
  });
  const setRequireResponseChatIds = ids => dispatch({
    type: "SET_REQUIRE_RESPONSE_IDS",
    ids
  });
  const setUnreadActive = value => dispatch({
    type: "SET_UNREAD_ACTIVE",
    value
  });
  const resetConversation = () => dispatch({
    type: "RESET"
  });
  const value = (0, _react.useMemo)(() => ({
    state,
    dispatch,
    adapter,
    chatClient,
    currentUser,
    selectConversation,
    setScreen,
    updateGroupMeta,
    setRequireResponseChatIds,
    setUnreadActive,
    resetConversation
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [state, adapter, chatClient, currentUser]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ConversationContext.Provider, {
    value: value,
    children: children
  });
}
function useConversationContext() {
  const ctx = (0, _react.useContext)(ConversationContext);
  if (!ctx) {
    throw new Error("useConversationContext must be used within a ConversationProvider");
  }
  return ctx;
}